module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('selectize', {
    attrs: {
      "load": _vm.loadResults,
      "focus": _vm.focus,
      "labelField": "firstName",
      "valueField": "id",
      "searchField": _vm.searchFields,
      "render": _vm.render,
      "maxOptions": "25",
      "openOnFocus": "true",
      "clear-selection": _vm.clearResult,
      "placeholder": "Quick search patient (2+ Characters)"
    },
    model: {
      value: (_vm.selection),
      callback: function($$v) {
        _vm.selection = $$v
      },
      expression: "selection"
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "busy_spinner"
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })]) : _vm._e()])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-dd90cbd4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd90cbd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/PatientSearchBox/PatientSearchBox.scp.html
// module id = 578
// module chunks = 0